(function () {
	var SEL = '.homeStripScroll';
	var CLASS_FITS = 'homeStripScroll--fits';
	/* Subpixels + scrollbar gutter often report 1–8px “overflow” when nothing really scrolls */
	var EPS_DEFAULT = 8;
	var EPS_FEW_ITEMS = 20;
	var FEW_ITEMS_MAX = 2;

	function stripItemCount(el) {
		var raw = el.getAttribute('data-home-strip-items');
		var n = raw != null ? parseInt(raw, 10) : NaN;
		return isNaN(n) ? 999 : n;
	}

	function maxScrollLeft(el) {
		var fromScroll = Math.max(0, el.scrollWidth - el.clientWidth);
		var inner = el.querySelector('.productsGrid--homeStrip');
		if (!inner) return fromScroll;
		var fromInner = inner.offsetWidth - el.clientWidth;
		/* Cap when scrollWidth is inflated past real content; never cap with a bogus 0 inner width */
		if (fromInner > 0 && fromInner < fromScroll) return fromInner;
		return fromScroll;
	}

	function clampScroll(el) {
		if (el.classList.contains(CLASS_FITS)) return;
		var max = maxScrollLeft(el);
		var x = el.scrollLeft;
		if (x > max) el.scrollLeft = max;
		if (x < 0) el.scrollLeft = 0;
	}

	function measure(el) {
		var max = maxScrollLeft(el);
		var eps = stripItemCount(el) <= FEW_ITEMS_MAX ? EPS_FEW_ITEMS : EPS_DEFAULT;
		var fits = max <= eps;
		el.classList.toggle(CLASS_FITS, fits);
		if (fits) {
			el.scrollLeft = 0;
		} else {
			clampScroll(el);
		}
	}

	function afterInteraction(el) {
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				clampScroll(el);
			});
		});
	}

	function init() {
		var nodes = document.querySelectorAll(SEL);
		if (!nodes.length) return;

		function bind(el) {
			measure(el);
			el.addEventListener(
				'scroll',
				function () {
					clampScroll(el);
				},
				{ passive: true }
			);
			el.addEventListener('touchend', function () {
				afterInteraction(el);
			}, { passive: true });
			el.addEventListener('touchcancel', function () {
				afterInteraction(el);
			}, { passive: true });
			el.addEventListener('scrollend', function () {
				clampScroll(el);
			}, { passive: true });
		}

		if (typeof ResizeObserver !== 'undefined') {
			var ro = new ResizeObserver(function (entries) {
				for (var i = 0; i < entries.length; i++) {
					var t = entries[i].target;
					var strip = t.matches && t.matches(SEL) ? t : t.closest && t.closest(SEL);
					if (strip) measure(strip);
				}
			});
			nodes.forEach(function (el) {
				bind(el);
				ro.observe(el);
				var inner = el.querySelector('.productsGrid--homeStrip');
				if (inner) ro.observe(inner);
			});
		} else {
			nodes.forEach(bind);
		}

		window.addEventListener('resize', function () {
			nodes.forEach(measure);
		});

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(function () {
				nodes.forEach(measure);
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
